/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class IntegratedToolProductActivation {
    getFixupPrototypeFunction() { return IntegratedToolProductActivation.fixupPrototype; }

    static newInstance(model: Partial<IntegratedToolProductActivation>): IntegratedToolProductActivation {
        let obj = Object.assign(new IntegratedToolProductActivation(), model);
        IntegratedToolProductActivation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<IntegratedToolProductActivation>): IntegratedToolProductActivation {
        if (!model) return null;
        return IntegratedToolProductActivation.newInstance(<IntegratedToolProductActivation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: IntegratedToolProductActivation) {
        if (!obj) return;

        models.IntegratedToolProductActivation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: IntegratedToolProductActivation): boolean {
        Object.setPrototypeOf(obj, IntegratedToolProductActivation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Resource category for Integrated Tool product activation
     */
    resource_category: string;

    /**
     * List of Resources in Integrated Tool Product Activation
     */
    resource: Array<string>;

}
